import React from 'react';
import { formatMarathiDate, toMarathiDigits } from '../../utils/marathi';
import './DetailModal.css';

export default function StaffDetailModal({ staff, onClose }) {
  if (!staff) return null;

  const categoryOptions = {
    administrative: 'Administrative',
    technical: 'Technical',
    support: 'Support',
    contracted: 'Contracted',
    elected_member: 'Elected Member',
    other: 'Other',
  };

  const availabilityOptions = {
    available: 'Available',
    on_leave: 'On Leave',
    retired: 'Retired',
    transferred: 'Transferred',
  };

  const calculateAge = (dob) => {
    if (!dob) return null;
    const today = new Date();
    const birthDate = new Date(dob);
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  };

  const age = staff.date_of_birth ? calculateAge(staff.date_of_birth) : null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <div>
            <h2>{staff.full_name}</h2>
            <p style={{ margin: '5px 0 0 0', color: '#666', fontSize: '14px' }}>
              {staff.designation}
              {staff.designation_marathi && ` (${staff.designation_marathi})`}
            </p>
          </div>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>

        <div className="modal-body">
          {/* Personal Information */}
          <div className="modal-section">
            <h3>व्यक्तिगत माहिती (Personal Information)</h3>
            <div className="detail-grid">
              {staff.gender && (
                <div className="detail-item">
                  <label>Gender:</label>
                  <span>{staff.gender}</span>
                </div>
              )}
              {staff.date_of_birth && (
                <div className="detail-item">
                  <label>Date of Birth:</label>
                  <span>
                    {formatMarathiDate(staff.date_of_birth)}
                    {age && ` (${toMarathiDigits(age)} years old)`}
                  </span>
                </div>
              )}
              {staff.category && (
                <div className="detail-item">
                  <label>Category:</label>
                  <span>{categoryOptions[staff.category] || staff.category}</span>
                </div>
              )}
              <div className="detail-item">
                <label>Status:</label>
                <span className={staff.is_active ? 'status-active' : 'status-inactive'}>
                  {staff.is_active ? 'Active' : 'Inactive'}
                </span>
              </div>
            </div>
            {staff.address && (
              <div className="detail-item full-width">
                <label>Address:</label>
                <p>{staff.address}</p>
              </div>
            )}
          </div>

          {/* Designation & Department */}
          <div className="modal-section">
            <h3>नियुक्ती (Designation)</h3>
            <div className="detail-grid">
              {staff.Department?.name && (
                <div className="detail-item">
                  <label>Department:</label>
                  <span>{staff.Department.name}</span>
                </div>
              )}
              {staff.appointment_date && (
                <div className="detail-item">
                  <label>Appointment Date:</label>
                  <span>{formatMarathiDate(staff.appointment_date)}</span>
                </div>
              )}
              {staff.availability && (
                <div className="detail-item">
                  <label>Availability:</label>
                  <span>{availabilityOptions[staff.availability] || staff.availability}</span>
                </div>
              )}
              {staff.office_location && (
                <div className="detail-item">
                  <label>Office Location:</label>
                  <span>{staff.office_location}</span>
                </div>
              )}
            </div>
          </div>

          {/* Contact Information */}
          <div className="modal-section">
            <h3>संपर्क माहिती (Contact Information)</h3>
            <div className="detail-grid">
              {staff.phone && (
                <div className="detail-item">
                  <label>Personal Phone:</label>
                  <span>{staff.phone}</span>
                </div>
              )}
              {staff.office_phone && (
                <div className="detail-item">
                  <label>Office Phone:</label>
                  <span>{staff.office_phone}</span>
                </div>
              )}
              {staff.email && (
                <div className="detail-item">
                  <label>Email:</label>
                  <span>{staff.email}</span>
                </div>
              )}
            </div>
          </div>

          {/* Professional Information */}
          {(staff.qualification || staff.experience_years || staff.specialization || staff.certifications) && (
            <div className="modal-section">
              <h3>व्यावसायिक माहिती (Professional Information)</h3>
              <div className="detail-grid">
                {staff.qualification && (
                  <div className="detail-item">
                    <label>Qualification:</label>
                    <span>{staff.qualification}</span>
                  </div>
                )}
                {staff.experience_years !== null && staff.experience_years !== undefined && (
                  <div className="detail-item">
                    <label>Experience:</label>
                    <span>{staff.experience_years} years</span>
                  </div>
                )}
                {staff.specialization && (
                  <div className="detail-item">
                    <label>Specialization:</label>
                    <span>{staff.specialization}</span>
                  </div>
                )}
              </div>
              {staff.certifications && (
                <div className="detail-item full-width">
                  <label>Certifications:</label>
                  <p>{staff.certifications}</p>
                </div>
              )}
            </div>
          )}

          {/* Visibility */}
          <div className="modal-section">
            <h3>दृश्यमानता (Visibility)</h3>
            <div className="detail-grid">
              <div className="detail-item">
                <label>Public Visible:</label>
                <span className={staff.public_visible ? 'status-active' : 'status-inactive'}>
                  {staff.public_visible ? 'Yes' : 'No'}
                </span>
              </div>
            </div>
          </div>

          {/* Metadata */}
          <div className="modal-section">
            <h3>माहिती (Metadata)</h3>
            <div className="detail-grid">
              <div className="detail-item">
                <label>Created:</label>
                <span>{formatMarathiDate(staff.created_at)}</span>
              </div>
              <div className="detail-item">
                <label>Updated:</label>
                <span>{formatMarathiDate(staff.updated_at)}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <button className="btn-secondary" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
}
